module.exports = __webpack_public_path__ + "img/DB4-1920_02.da4e3a19.jpg";